import { useEffect, useRef } from 'react';

const useInfiniteScroll = (elemId, myCallBack, filters) => {
  const endReached = useRef(false);
  const prevFilters = useRef(filters);

  /**
   * endReached purpose is to stop unnecessary api calls
   * endReached checks received array and if the array is empty updates the list
   * as endReached, and on filter change it reverts the state back
   * for endReached to work, original fetch function should return data length
   */
  useEffect(() => {
    endReached.current = false;
  }, []);

  useEffect(() => {
    if (!filters) return;
    if (JSON.stringify(prevFilters.current) !== JSON.stringify(filters)) {
      endReached.current = false;
    }

    prevFilters.current = filters;
  }, [filters]);

  /**
   * Listen to scroll event for given element/div id
   */
  useEffect(() => {
    const scrollEl = !elemId ? document : document.getElementById(elemId);

    if (!scrollEl) return;

    scrollEl.addEventListener('scroll', onScroll);

    return () => scrollEl.removeEventListener('scroll', onScroll);
  }, [elemId, myCallBack]);

  /**
   * Trigger on scroll event from listener,
   * if checks meet do callback
   */
  async function onScroll(e) {
    /**
     * Distance from list end to trigger the callback
     */
    const target = elemId ? e.target : e.target.body;
    const bottomThreshold = target.scrollHeight - target.clientHeight,
      scrollHt = (!elemId ? window.scrollY : target.scrollTop) + 200;

    if (scrollHt <= bottomThreshold || endReached.current) return;

    const len = myCallBack && (await myCallBack());

    if (typeof len !== 'number' || len === 'undefined') return;
    if (len) return;

    endReached.current = true;
  }
};

export default useInfiniteScroll;
